import axios from "axios";
import { RISTA_API_URL, RISTA_CUSTOM_URL } from "../config";
import { AUTH_TOKEN, DEVICE_IDENTIFIER, STATE } from "../data/local-storage-constants";
import { LOGIN_PAGE_ROUTE } from "../data/routes-constants";
import {
  getErrorMessage,
  pos_errormap_without_label,
  pos_errormap_with_label,
} from "../helpers/errors-helper";
import history from "../history";
import { saveRequestHeaderData } from "../redux/slices";
import store from "../redux/store";
import { getLocalStorage, removeLocalStorage } from "../utils";
import { toastClear, toastError } from "../utils/react-toaster";
import { checkSupportLogout } from "../helpers/common-helper";

const defaultOptions = {
  baseURL: `${RISTA_API_URL}business/services`,
  headers: {
    "Content-Type": "application/json",
  },
};

const api = axios.create(defaultOptions);

api.interceptors.request.use((config: any) => {
  config.headers["atoken"] =
    getLocalStorage(AUTH_TOKEN) || process.env.REACT_APP_RISTA_API_ATOKEN;
  config.headers["deviceidentifier"] =
    getLocalStorage(DEVICE_IDENTIFIER) ||
    process.env.REACT_APP_RISTA_API_DEVICEIDENTIFIER;
  if (
    config.url.includes("/bn/catalog/upload") ||
    config.url.includes("/bn/catalog/image/update") ||
    config.url.includes("/bn/catalog/price/upload") ||
    config.url.includes("/bn/optionset/upload") ||
    config.url.includes("/bn/options/bulkupdate")
  ) {
    config.headers["Content-Type"] = "multipart/form-data";
  }
  config.headers["Access-Control-Allow-Origin"] = "*";
  if (config.customUrl) {
    config.baseURL = `${RISTA_API_URL}${RISTA_CUSTOM_URL}`;
  }

  let requestHeader = !!store.getState()?.requestHeadersReducer?.data
    ? JSON.parse(JSON.stringify(store.getState().requestHeadersReducer.data))
    : {};
  config.headers["If-Modified-Since"] = !!requestHeader?.[config.url]
    ? requestHeader[config.url]
    : null;
  // isNew key helps BE identifying requests from new ui
  config.headers.isNew = true;
  return config;
});

api.interceptors.response.use((response: any) => {
  let requestHeader = !!store.getState()?.requestHeadersReducer?.data
    ? JSON.parse(JSON.stringify(store.getState().requestHeadersReducer.data))
    : {};
  if (!!response?.headers?.["last-modified"] && response?.config?.url) {
    requestHeader[response.config.url] = response?.headers?.["last-modified"];
    store.dispatch(saveRequestHeaderData(requestHeader));
  }
  let errorCodes = [
    "IDLE_TIMEOUT",
    "UNAUTHENTICATED_USER",
    "REST_LICENCE_OPERATION_FAILED",
    "REST_STALE_CLIENT_VERSION",
  ];
  if (response?.data?.code && errorCodes.indexOf(response?.data?.code) !== -1) {
    removeLocalStorage(AUTH_TOKEN);
    removeLocalStorage(STATE);
    checkSupportLogout()
    history.push(LOGIN_PAGE_ROUTE);
  }

  let errorCode = response?.data?.code;
  if (
    errorCode &&
    (pos_errormap_without_label[errorCode] ||
      !pos_errormap_with_label[errorCode])
  ) {
    toastClear();
    let errMsg = getErrorMessage(pos_errormap_without_label, errorCode);
    errMsg && toastError(errMsg);
  }
  return response.data;
});

export default api;
